// The PTA report routes of a work item (annulling the reported deviation at
// Ruter, and the history of what was sent), split out of the grandfathered
// `apiRoutes.ts` so these routes do not grow that file (it is exempt from
// `max-lines`, not allowed to keep expanding). `apiRoutes` spreads this object,
// so consumers keep importing `apiRoutes.annulPtaReport` etc.
//
// `as const` is required: without it `method` widens to `string` and the
// `satisfies Record<string, RouteDefinition>` check in `apiRoutes.ts` fails.
export const ptaReportRoutes = {
  getPtaAnnulReasons: {
    method: 'get',
    path: () => `/WorkItems/pta-annul-reasons`,
  },
  annulPtaReport: {
    method: 'post',
    path: (id: number | string) => `/WorkItems/${id}/pta-report/annul`,
  },
  getPtaReportHistoryByWorkItemId: {
    method: 'get',
    path: (id: number | string) => `/WorkItems/${id}/pta-report-history`,
  },
} as const;
